import { useEffect, useState } from "react";

/**
 * `E.5` (Ф2, макет `MobileConsumption.dc.html`): узкий ли экран.
 *
 * На телефоне таблица расхода не помещается, и строки показываются списком. Вид
 * выбирается **один**: два вида сразу (таблица и список) дали бы две копии
 * данных в разметке — лишнее чтение для диктора и двойные совпадения по тексту.
 *
 * Ширина — точка макета: до `860px` включительно — список. В среде без
 * `matchMedia` (проверки в jsdom) считаем экран широким: таблица.
 */
export const NARROW_VIEWPORT_QUERY = "(max-width: 860px)";

function readMatches(query: string): boolean {
  if (typeof window === "undefined" || typeof window.matchMedia !== "function") {
    return false;
  }

  return window.matchMedia(query).matches;
}

export function useNarrowViewport(query: string = NARROW_VIEWPORT_QUERY): boolean {
  const [narrow, setNarrow] = useState(() => readMatches(query));

  useEffect(() => {
    if (typeof window === "undefined" || typeof window.matchMedia !== "function") {
      return undefined;
    }

    const media = window.matchMedia(query);
    const update = () => setNarrow(media.matches);

    update();

    // `addEventListener` есть не везде: старые Safari знают только `addListener`.
    if (typeof media.addEventListener === "function") {
      media.addEventListener("change", update);
      return () => media.removeEventListener("change", update);
    }

    if (typeof media.addListener === "function") {
      media.addListener(update);
      return () => media.removeListener(update);
    }

    return undefined;
  }, [query]);

  return narrow;
}
